export default class EOB {
  public static readonly LIST_EOB = '/eob/search';
}
